import { useParams } from "react-router";
import { RecordingsPage } from "./RecordingsPage";
import { ReplayModal } from "./SshRecordings";

export function DatabaseRecordings() {
  const { orgId } = useParams();

  return (
    <RecordingsPage
      connectionMethod="PostgresWireProtocol,MySQLProtocol"
      label="database"
      emptyDescription="Recorded sessions will appear here after people connect to a database."
      extraColumn={{
        label: "Kind",
        render: (recording) => recording.resourceKind ?? "Unknown",
      }}
      renderModal={(recording, onClose) =>
        orgId && (
          <ReplayModal orgId={orgId} recording={recording} onClose={onClose} />
        )
      }
    />
  );
}
